import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import SelectVirtualized from '../../../../../../../../components/Select/Virtualized';

import { getSelectedValue } from './helper';
import * as types from '../../reducer/constants';

const FieldSubscription = ({ modal, form, dispatchServiceData }) => {
  const { subscriptionTypes } = useSelector((state) => state.services);
  const { subscription_type } = form;
  const isEdit = modal?.id;

  const selectedValue = useMemo(() => getSelectedValue(subscriptionTypes, subscription_type, modal), [modal, subscriptionTypes, subscription_type]);
  const selectOptions = useMemo(() => subscriptionTypes
    .filter((type) => {
      /*
        Таска https://www.notion.so/perfectpanel/Facebook-Auto-type-Subscription-Services-db842cee419746a889d6a46b4922314a
       */
      if (type.available) {
        return isEdit ? type.available.edit : type.available.create;
      }
      return true;
    })
    .map((type) => ({
      label: type.name,
      value: type.id,
    })), [isEdit, subscriptionTypes])
  const isDisabled = !!modal?.id;

  const onChange = (selected) => {
    const value = Number(selected.value);
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SUBSCRIPTION_TYPE, value })
  };

  return (
    <FormGroup className="form-group__subscription">
      <ControlLabel>Subscription</ControlLabel>
      <SelectVirtualized
        name="link_type"
        components={{ IndicatorSeparator: null }}
        onChange={onChange}
        isDisabled={isDisabled}
        noOptionsMessage={() => 'Subscription not found'}
        hideSelectedOptions={false}
        value={selectedValue}
        options={selectOptions}
        maxMenuHeight={208}
        placeholder="Choose subscription type"
      />
    </FormGroup>
  );
};

FieldSubscription.propTypes = {
  modal: PropTypes.object,
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldSubscription;
